module.exports = __webpack_public_path__ + "img/event-frame04.b130a90d.png";